module.exports = __webpack_public_path__ + "static/media/nfc.628b0c84.jpg";